import DataGrid2 from '../..';
import { IControlProperties } from '../../../../../../entities';
import { IDataGridColumn } from '../../entities';

export function onSummaryChanged(
	this: {
		self: DataGrid2;
		column: IDataGridColumn<IControlProperties>;
		summaryType: any;
	},
	item: { value: string; valueText: string }
) {
	this.self.emit('event:OnSummaryChanged', {
		columnName: this.column.name,
		value: item.value,
		type: this.summaryType.type
	});

	return item.valueText;
}
